import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import React, { useCallback, useState } from "react";

function CopyButton({ textToCopy }) {
  const [copied, setCopied] = useState(false);

  const handleClick = useCallback(async () => {
    setCopied(true);
    await navigator.clipboard.writeText(textToCopy);
    setTimeout(() => setCopied(false), 2000);
  }, [textToCopy]);

  return (
    <>
      <Tooltip title={copied ? "Copied!" : "Copy to clipboard"} arrow>
        <IconButton aria-label="copy" onClick={handleClick}>
          <ContentCopy />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default CopyButton;
